import { genOssTmpToken } from '@/api/oss'
import OSS from 'ali-oss'

export async function getOssClient() {
  try {
    const response = await genOssTmpToken()

    console.log(response)

    const ossClient = new OSS({
      region: 'oss-cn-shenzhen',
      accessKeyId: response.data.accessKeyId,
      accessKeySecret: response.data.accessKeySecret,
      stsToken: response.data.securityToken,
      bucket: 'mj-comfy-ui',
      secure: true
    })

    return ossClient
  } catch (error) {
    console.error('Failed to initialize OSS client:', error)
    throw error
  }
}
